export class PreviewUtil {
    static getTitleFromResponse(res) {
        const choices = res?.data?.choices || [];
        let title = undefined;
        let subTitle = undefined;
        for (const choice of choices) {
            const text = choice.text || choice.message?.content || "";
            const keyValues = text.split("\n").filter((x) => x.trim() !== "");
            const results = keyValues.map((kv) => {
                const [title, content] = kv.split(": ");
                return { title: title.trim(), content: content.trim() };
            });
            const foundTitle = results.find((result) => result.title.toLowerCase().includes("title"));
            if (foundTitle) {
                title = foundTitle.content;
            }
            const foundSubtitle = results.find((result) => result.title.toLowerCase().includes("description"));
            if (foundSubtitle) {
                subTitle = foundSubtitle.content;
            }
            if (title && subTitle) {
                break;
            }
        }
        return { title, subTitle };
    }
    /**
     * 将host 和 domain 组装起来
     * @param host
     * @param domain
     */
    static combineHostAndDomain(host, domain) {
        let hostNew = host.trim();
        let domainNew = domain.trim();
        if (hostNew.endsWith(".")) {
            hostNew = hostNew.substring(0, hostNew.length - 1);
        }
        if (domainNew.startsWith(".")) {
            domainNew = domainNew.substring(1, domainNew.length - 1);
        }
        return hostNew + "." + domainNew;
    }
}
